import GCarousel from "./g-carousel";

class CartUpsellCollection extends GCarousel {
  constructor() {
    super();
  }

  async connectedCallback() {
    await super.connectedCallback();
    this.minItemCount = this.dataset.minItemCount || 0;
    this.productCount = this.querySelectorAll(".splide__slide").length || 0;
    document.documentElement.addEventListener(
      "product:added",
      this._onProductAdded.bind(this)
    );
  }

  async _onProductAdded(e) {
    const variantId = parseInt(e.detail.variant);
    if (variantId) {
      const items = this.querySelectorAll("product-item, cart-drawer-recommendations-item");
      for (let item of items) {
        if (item.variants.variants.indexOf(variantId) !== -1) {
          item.closest(".splide__slide").remove();
          this.productCount = this.productCount - 1;
          if(this.splide && window.innerWidth <= 640) {
            this.splide.refresh();
          }
          break;
        }
      }
    }
    if(this.productCount <= this.minItemCount) {
      await this.fetchItems();
      this.productCount = this.querySelectorAll(".splide-slide").length || 0;
      if(this.productCount === 0) {
        this.setAttribute('aria-hidden', true);
      }
    }
  }
}

customElements.define("cart-upsell-collection", CartUpsellCollection);
